import Edit16 from '@carbon/icons-react/es/edit/16';
import styled from 'styled-components';
import { InputNumber } from 'components/atoms/input';
import { Table } from 'components/molecules/table';
import { NameCell } from 'components/organisms/timesheets/common/cells/name-cell';
import { SingleLineEllipsis } from 'components/styles';

export const StyledTable = styled(Table)`
  position: relative;
  margin: var(--spacing-05) 0;

  .ant-table-cell {
    background-color: transparent;
    padding: 0;
  }

  .ant-table-row {
    &:hover {
      > td {
        background-color: var(--gray-10) !important;
      }
    }
  }

  &.disabled::after {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    background-color: var(--white-100);
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const NameRenderer = styled(NameCell)`
  padding-top: 0;
  padding-bottom: 0;
  height: var(--spacing-09);
  display: flex;
  align-items: center;
`;

export const RateInput = styled(InputNumber)`
  background-color: transparent;
  border: none;
  height: var(--layout-04);

  input {
    height: var(--layout-04) !important;
  }

  &.ant-input-number-readonly,
  &.ant-input-number-readonly.ant-input-number-focused {
    outline: none;
  }
`;

export const UpdatedByWrapper = styled.div`
  padding: var(--spacing-05);
`;

export const TextWrapperWithEllipsis = styled.div`
  ${SingleLineEllipsis};
`;

export const ReferenceTeamWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;

export const EditIcon = styled(Edit16)`
  visibility: hidden;
  &:hover {
    color: var(--blue-60);
  }
  cursor: pointer;
`;

export const BillingInfoTable = styled(StyledTable)`
  .ant-table-row {
    height: var(--spacing-08);
  }
  .ant-table-row:nth-child(even) {
    background-color: var(--coolest-gray-10);
  }
  .ant-table-row:hover {
    ${EditIcon} {
      visibility: visible;
    }
  }
  .ant-table-cell {
    padding: 0 var(--spacing-05);
    border-bottom: none;
  }
  margin-bottom: var(--spacing-08);
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-04);
`;

export const InfoWrapper = styled.div`
  color: var(--gray-50);
`;

export const RateCardInfo = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
`;

export const CostRateWrapper = styled.div`
  padding: 0 var(--spacing-05);
`;
